import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import { Link } from 'react-router-dom';
// import { Media } from 'react-bootstrap';

import styles from './styles.module.scss';
import DOMPurify from 'dompurify';
import _ from "lodash";
import { localizedStrings } from 'src/localization';
import Text from 'src/components/text';

class ContactListView extends React.Component {
  constructor(props){
    super(props);

    this.handleContactClick = this.handleContactClick.bind(this);
    
    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons

  }

  handleContactClick() {
    if(this.props.onSelection) {
      this.props.onSelection(this.props.contact);
    }
  }

  render() {
    return (
      <div>
        {this.props.editable && this.renderContact()}
        {!this.props.editable && this._wrapContactWithLink(this.renderContact())}
      </div>
    )
  }

  _wrapContactWithLink(contact) {    
    var url = this.props.url;

    if(!url){
      url = `/settings/contact_list/${this.props.contactList.id}`;
    }
    return (
      <Link to={url} className={cx(styles.contact, 'contact_list', this.props.className)}>
        {contact}
      </Link>
    )
  }


  renderContact() {
    return (
      <div key={this.props.contactList.id} className={styles.inner} onClick={this.handleContactClick}>
        <div className={styles.left}>
          <div className={styles.iconContainer}>
              <div className={styles.contactAvatar}> 
              <i className="paperflite-group" />
              </div>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.contactName}>
            <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.contactList.name) }}></div>
          </div>
          <div className={styles.contactTitle}>
            <Text lines={1}
              text = { _.get(this.props, "contactList.contactCount") === 0 ? this.localizedCommons.no_contacts : _.get(this.props, "contactList.contactCount") === 1
              ? `${_.get(this.props, "contactList.contactCount")} ${this.localizedKeywords.contact}`
              : `${_.get(this.props, "contactList.contactCount")} ${this.localizedKeywords.contacts}`}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default ContactListView;